module.exports = __webpack_public_path__ + "img/56_76.ce6582de.png";